// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e806aeb","455":"37d09add","977":"1ee2bce0"}[chunkId] + ".chunk.js";
};